module.exports = __webpack_public_path__ + "img/qa.db74560b.svg";